import * as React from "react";
import type { SVGProps } from "react";
export const SvgMapMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill="currentColor"
      d="M10.712 10.129 7 13.84 3.288 10.13a5.25 5.25 0 1 1 7.424 0ZM7 7.583A1.167 1.167 0 1 0 7 5.25a1.167 1.167 0 0 0 0 2.333Z"
    />
  </svg>
);
